import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Joins class names and lets a caller's utility win over a component default
 * (`cn('px-4', 'px-6')` → `px-6`), so variants stay overridable without `!important`.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map